import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { FN_GENERATION__update_locally } from '../_methods/FN_GENERATION__update_locally';
import { STATE__generation } from '../STATE__generation';

export const LOCAL__generation_upsert_generation = (payload: DTO__generation[]): PayloadAction<DTO__generation[]> => ({
  type: ENUM__redux_action.GENERATION_UPSERT,
  payload,
});

export function init_local_generation_upsert_generation(state: STATE__generation, action: PayloadAction<DTO__generation[]>) {
  if (action.payload.is_empty()) return;

  for (let generation_new of action.payload) {
    //update current generation
    FN_GENERATION__update_locally(state, generation_new);
  }
}
